export const RESULTS_PAGE = 7;
